<script>
export default {
    name: 'CsrReports',

    props: ['items'],

    data() {
        return {
            loadMore: false,
        }
    },

    computed: {
        loadedItems() {
            if (this.loadMore) {
                return this.items
            }

            return this.items.slice(0, 3);
        }
    }
}
</script>
